module.exports = __webpack_public_path__ + "img/USADDTDetailed-min.17c78a37.png";